var swatchElements = document.querySelectorAll(".service-swatch");
var priceElement = document.querySelector(".product-form__info-content .price-list .price");
var swatchGroups = document.querySelectorAll(".service-swatch-group");
// Extract main product price
var mainProductPriceText = priceElement.textContent.replace(/[^0-9]/g, "");
var mainProductPrice = parseInt(mainProductPriceText, 10) || 0;
var quantity = 1;

// Function to save selected values for each service
function saveSelectedValues() {
  swatchGroups.forEach(function (group, index) {
    var selectedSwatch = group.querySelector(".service-swatch.selected");
    var selectedValue = selectedSwatch ? selectedSwatch.getAttribute("data-extra-price") : null;
    
    // Store the selected service value in sessionStorage with a unique key for each service
    sessionStorage.setItem("selectedService" + index, selectedValue);
    // Update the selected title
    updateSelectedSwatchTitle(group, selectedSwatch);
  });
}

// Function to restore selected values for each service (without selecting any swatch initially)
function restoreSelectedValues() {
  swatchGroups.forEach(function (group, index) {
    // Simply clear the selected state by removing the "selected" class
    var swatches = group.querySelectorAll(".service-swatch");
    swatches.forEach(function (swatch) {
      swatch.classList.remove("selected");
    });
    // Update the title to 'None' if no swatch is selected
    updateSelectedSwatchTitle(group, null);
  });
}

// Function to update the selected swatch title
function updateSelectedSwatchTitle(group, selectedSwatch) {
  var selectedSwatchTitle = group.querySelector('#selected-swatch-title');
  if (selectedSwatch) {
    selectedSwatchTitle.textContent = ' - '+ selectedSwatch.getAttribute("data-service-title") || 'None';
  } else {
    selectedSwatchTitle.textContent = ' - None';
  }
}

// Function to update the total price based on selected swatches for each service
function updateTotalPrice() {
  var totalPrice = mainProductPrice;

  swatchGroups.forEach(function (group) {
    var selectedSwatch = group.querySelector(".service-swatch.selected");
    if (selectedSwatch) {
      var extraPriceText = selectedSwatch.getAttribute("data-extra-price") || "0";
      var extraPrice = parseInt(extraPriceText.replace(/[^0-9]/g, ""), 10) || 0;
      totalPrice += extraPrice;
    }
  });

  // Format and update the price element
  var formattedPrice = (totalPrice / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  priceElement.textContent = `$${formattedPrice}`;
}

// Attach event listeners to each swatch for individual selection
swatchGroups.forEach(function (group) {
  var swatchElements = group.querySelectorAll(".service-swatch");

  swatchElements.forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      
      // Deselect all swatches in the current group first
      swatchElements.forEach(function (s) {
        s.classList.remove("selected");
      });

      // Select the clicked swatch
      swatch.classList.add("selected");
      saveSelectedValues();
      updateTotalPrice();
    });
  });
});

// Restore selected values and update total price on page load
restoreSelectedValues();
updateTotalPrice();

var additionalServicesContainer = document.querySelector('.product-additional-services');
if (additionalServicesContainer && additionalServicesContainer.innerHTML.trim() !== '') {
  // Hook into the add-to-cart action
  document.querySelector('[data-action="add-to-cart"]').addEventListener("click", function (event) {
    event.preventDefault();
  
    var formElement = document.querySelector('form[action*="/cart/add"]');
    
    var mainProductId = formElement.querySelector('[name="id"]').value;
    var selectedServices = [];
    var serviceTitles = [];
    var servicePrices = [];
    var totalServicePrice = 0;
  
    // Generate a unique group ID for this set of items
    var groupId = `group_${Date.now()}`;
  
    // Extract service data for each selected swatch
    swatchGroups.forEach(function (group) {
      var selectedSwatch = group.querySelector(".service-swatch.selected");
      if (selectedSwatch) {
        var serviceVariantId = selectedSwatch.getAttribute("data-variant-id");
        var serviceExtraPrice = parseFloat(selectedSwatch.getAttribute("data-extra-price").replace(/[^0-9.-]+/g, "")) || 0;
  
        // Only include the service if it has a valid variant ID and price > 0
        if (serviceVariantId && serviceExtraPrice > 0) {
          selectedServices.push({
            id: serviceVariantId,
            quantity: parseInt(formElement.querySelector('[name="quantity"]').value, 10),
            // properties: {
            //    addon_for: mainProductId,
            // },
          });
  
          serviceTitles.push(selectedSwatch.getAttribute("data-service-title"));
          servicePrices.push(serviceExtraPrice.toFixed(2));
          totalServicePrice += serviceExtraPrice;
        }
      }
    });
  
    var priceElement = document.querySelector(".product-form__info-content .price-list .price");
    var mainProductPriceText = priceElement.textContent.replace(/[^0-9]/g, "");
    var mainProductPrice = parseInt(mainProductPriceText, 10) || 0;
  
    var totalPriceWithServices = (mainProductPrice / 100) * parseInt(formElement.querySelector('[name="quantity"]').value, 10);
  
    var mainProductData = {
      id: formElement.querySelector('[name="id"]').value,
      quantity: parseInt(formElement.querySelector('[name="quantity"]').value, 10),
    };
  
    // Only add properties if there are valid selected services with a price > 0
    if (totalServicePrice > 0 && servicePrices.length > 0) {
      mainProductData.properties = {
        "Selected Service": serviceTitles.join(",\n "),
      };
    }
  
    var cartItems = [...selectedServices, mainProductData];
  
    var cartAddUrl = window.routes?.cartAddUrl || "/cart/add";
  
    fetch(`${cartAddUrl}.js`, {
      body: JSON.stringify({ items: cartItems }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (response) {
        if (response.ok) {
          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: mainProductData,
                button: event.target,
                quantity: mainProductData.quantity,
              },
            })
          );
          // console.log("Successfully added to cart:", cartItems);
          window.location.href = "/cart";
        } else {
          console.error("Error adding to cart");
        }
      })
      .catch(function (error) {
        console.error("Fetch error:", error);
      });
  });
}